
// 获取微信配置信息的接口
import { wxshare } from '../api/api'
import wx from 'weixin-js-sdk'
const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
}
export default {

  wxShareMethod: function (options) {

    return new Promise((res, err) => {
      if (window.location.hostname != 'pay.iceriverbj.com' || !isWeixin()) {
        err()
        return
      }
      const url = window.location.href.split('#')[0]
      var data1 = {
        url: url
      }
      // 获取微信配置信息的接口
      wxshare(data1).then(data => {

        wx.config({
          debug: false,

          appId: data.appId,

          timestamp: data.timestamp,

          nonceStr: data.nonceStr,

          signature: data.signature,

          jsApiList: [

            'onMenuShareTimeline',

            'onMenuShareAppMessage',

          ]
        })

        res()
        wx.onMenuShareAppMessage(options)
        wx.onMenuShareTimeline(options)
      }).catch((e) => {
        err()
      })
    })


  },





}
